/*
 * the SearchService class handles donna-wide searches
 * http://stackoverflow.com/questions/34755350/using-http-rest-apis-with-angular-2/34758630#34758630 (see accepted answer by Pardeep Jain)
 * http://stackoverflow.com/questions/37290672/passing-parameters-in-http-get-using-angular-2 (see accepted answer by Pardeep Jain)
 * https://angular.io/docs/ts/latest/guide/server-communication.html#!#error-handling
 * by ole fjarestad
 */

import { Injectable } from '@angular/core';
import { Http, Headers, Request, RequestOptions, RequestMethod, URLSearchParams, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { api } from './api';


@Injectable()
export class SearchService {

	private searchUrl: string = 'http://swapi.co/api/people/'; // #RPT: replace with search endpoint when in place

	constructor(private http: Http) { }

	// private getHeaders() {
	private getRequestOptions( options ) {
		let headers = new Headers();
		headers.append( 'Accept', 'application/json' );
		options.headers = headers;
		let requestOptions = new RequestOptions(options);
		return requestOptions;
	}

	private handleError(error: Response | any) {
		return Observable.throw(error);
	}

	search(searchQuery: string): Observable<[{}]> { // see http://embed.plnkr.co/rDiKhxaITrZJusKsRMEi/ for improvements to search

		var params = new URLSearchParams();
		params.set( 'søk', searchQuery ); // need to test this when search endpoint is in place
		var requestOptions = {
			withCredentials: true,
			method: RequestMethod.Get,
			url: this.searchUrl,
			search: params,
		}

		let results$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) ) // #RPT: replace with line above when requesting same origin-resources
						//.do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json().results )
						//.do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return results$
	}
	
}



// WEBPACK FOOTER //
// ./src/app/search.service.ts